export const isProductDNA = () =>
  location.hostname.endsWith('productdna.supplierxm.salsify.com');

export const isLeclerc = () =>
  new URLSearchParams(location.search).has('leclerc');
